export default __webpack_public_path__ + "static/media/fowler-plant-aerial.c723815b.jpg";